import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';
import { Heading, Text } from '@/Components/ui/typography';
import { Stack, Inline } from '@/Components/ui/layout';
import { Separator } from '@/Components/ui/separator';
import { Avatar, AvatarFallback } from '@/Components/ui/avatar';
import { Download, ChevronRight } from 'lucide-react';

function EmployerCard({ name, role, experience, education, appliedDate }) {
  const navigate = useNavigate();
  const handleViewProfile = () => {
    navigate('/hirewithus/employerpage/employerpf')
  }
  
  return (
    <div className="w-[300px] flex flex-col gap-5 bg-white rounded-xl shadow-md transition-all hover:-translate-y-1 hover:shadow-lg">
      <Card className="rounded-xl border border-slate-200 p-5 flex flex-col gap-4">
        <CardContent className="p-0">
          <Inline spacing="md" className="gap-4 items-center">
            <Avatar className="w-14 h-14 rounded-full bg-slate-300">
              <AvatarFallback className="bg-slate-300 text-white">
                {name.split(' ').map(n => n[0]).join('')}
              </AvatarFallback>
            </Avatar>
            <Stack spacing="xs">
              <Heading level="h3" size="lg" className="text-slate-900 font-semibold m-0">
                {name}
              </Heading>
              <Text size="base" className="text-slate-500 mt-1 mb-0">
                {role}
              </Text>
            </Stack>
          </Inline>
          <Separator className="my-4 border-t border-slate-200" />
          <Stack spacing="xs" className="text-base text-slate-600">
            <Text size="base" className="my-1.5">{experience}</Text>
            <Text size="base" className="my-1.5">Education: {education}</Text>
            <Text size="base" className="my-1.5">Applied: {appliedDate}</Text>
          </Stack>
          <Button variant="ghost" className="flex items-center gap-2 text-blue-600 font-medium bg-transparent p-0 hover:text-blue-800">
            <Download className="w-5 h-5" />
            <span>Download CV</span>
          </Button>
        </CardContent>
      </Card>
      <Button 
        className="flex justify-center items-center gap-2 w-[90%] p-4 bg-blue-600 text-white rounded-lg text-base font-semibold capitalize transition-all hover:bg-blue-800 hover:-translate-y-0.5 -mt-5 ml-[15px]"
        onClick={handleViewProfile}
      >
        <span>View Profile</span>
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
}

export default EmployerCard;